import { render, staticRenderFns } from "./CategoryStockRecordTable.vue?vue&type=template&id=7cf4cc86&"
import script from "./CategoryStockRecordTable.vue?vue&type=script&lang=js&"
export * from "./CategoryStockRecordTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports